<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar></sidebar>
    <div class="page-wrapper">
      <div class="content">
        <pageheader :title="title" :title1="title1" />
        <!-- /add -->
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>Customer Name</label>
                  <b-form-input type="text"  v-model="form.customername" ref='firstInput' @keypress.enter="submitForm()"/>
                </div>
              </div>
              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>Mobile</label>
                  <InternationalPhoneInput
                    ref="mobileInput"
                    v-model="form.mobile"
                    :submitted="phoneSubmitted"
                    @enter="submitForm()"
                  />
                </div>
              </div>
              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>GST No</label>
                  <b-form-input type="text"  v-model="form.gstno" @keypress.enter="submitForm()"/>
                </div>
              </div>
              <div class="col-lg-9 col-12">
                <div class="form-group">
                  <label>Address</label>
                  <b-form-input type="text"  v-model="form.address" @keypress.enter="submitForm()"/>
                </div>
              </div>
              <div class="col-lg-12">
                <a v-on:click="postData()" class="btn btn-submit me-2">Submit</a>
                <router-link to="customerlist" class="btn btn-cancel">Cancel</router-link>
              </div>
            </div>
          </div>
        </div>
        <!-- /add -->
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import InternationalPhoneInput from "@/components/InternationalPhoneInput.vue";
axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.defaults.headers.post['Content-Type'] ='application/json;charset=utf-8';
export default {
  components: { InternationalPhoneInput },
  data() {
    return {
      form: {
        customername: '',
        mobile: '',
        gstno: '',
        address:'',
      },
      phoneSubmitted: false,
      title: "Customer Management",
      title1: "Add Customer",
    };
  },
  methods: {
    async postData() {
      if (!this.form.customername) {
        Swal.fire("Please enter the customer name");
        return;
      }
      this.phoneSubmitted = true;
      if (!this.$refs.mobileInput.validate()) {
        Swal.fire("Please enter a valid mobile number");
        return;
      }
      const result = await Swal.fire({
        title: 'Are you sure?',
        text: "Do you really want to submit the form?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, submit it!'
      });

      if (result.isConfirmed) {
      axios
      .post('/v1/customers', this.form)
      .then(response => {
        Swal.fire("Customer created successfully");
        this.$router.push({ path: '/customerlist' });
      })
      .catch(error => {
        console.log(error)
        Swal.fire(error.response.data.detail);
      });
      }
    },
    submitForm() {
      this.postData();
    }
  },
  mounted(){
    this.$refs.firstInput.focus();
  },
  name: "addcustomer",
};
</script>
